import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form", attrs: { id: "inventoryReservationForm" } },
    [
      _vm.loaded
        ? _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(VTextField, {
                attrs: { label: "Worksheet ID", required: false },
                model: {
                  value: _vm.inventoryReservation.processWorksheetId,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.inventoryReservation,
                      "processWorksheetId",
                      $$v
                    )
                  },
                  expression: "inventoryReservation.processWorksheetId",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Inventory ID", required: false },
                model: {
                  value: _vm.inventoryReservation.inventoryId,
                  callback: function ($$v) {
                    _vm.$set(_vm.inventoryReservation, "inventoryId", $$v)
                  },
                  expression: "inventoryReservation.inventoryId",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Inventory Unit ID", required: false },
                model: {
                  value: _vm.inventoryReservation.inventoryUnitId,
                  callback: function ($$v) {
                    _vm.$set(_vm.inventoryReservation, "inventoryUnitId", $$v)
                  },
                  expression: "inventoryReservation.inventoryUnitId",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Quantity", required: false },
                model: {
                  value: _vm.inventoryReservation.quantity,
                  callback: function ($$v) {
                    _vm.$set(_vm.inventoryReservation, "quantity", $$v)
                  },
                  expression: "inventoryReservation.quantity",
                },
              }),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-space-between" },
                [
                  _c(VBtn, { on: { click: _vm.goBack } }, [
                    _vm._v(" Back "),
                  ]),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" " + _vm._s(_vm.id ? "Update" : "Save") + " ")]
                  ),
                  _c("span"),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }